var _g, _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2782 20H20.864C21.645 20 22.2782 19.3668 22.2782 18.5858C22.2782 18.2107 22.1292 17.851 21.864 17.5858L20.864 16.5858C20.4889 16.2107 20.2782 15.702 20.2782 15.1716L20.2782 11.9707C20.2782 7.56859 16.7096 4 12.3075 4C7.89609 4 4.32363 7.58319 4.33687 11.9946L4.34634 15.1476C4.34797 15.6922 4.12748 16.2139 3.73579 16.5922L2.70683 17.586C2.4329 17.8506 2.2782 18.2151 2.2782 18.5959C2.2782 19.3714 2.90683 20 3.68228 20H8.2782C8.2782 22.2091 10.0691 24 12.2782 24C14.4873 24 16.2782 22.2091 16.2782 20ZM19.8033 17.6464L20.6569 18.5H3.91966L4.77787 17.6711C5.46333 17.009 5.84919 16.0961 5.84633 15.1431L5.83687 11.9901C5.82612 8.40887 8.72627 5.5 12.3075 5.5C15.8812 5.5 18.7782 8.39702 18.7782 11.9707L18.7782 15.1716C18.7782 16.0998 19.1469 16.9901 19.8033 17.6464ZM14.7782 20H9.7782C9.7782 21.3807 10.8975 22.5 12.2782 22.5C13.6589 22.5 14.7782 21.3807 14.7782 20Z",
    fill: "#3D3839"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7441,
    cy: 5,
    rx: 5.12968,
    ry: 5,
    fill: "#F47D20",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8737 5C22.8737 7.18515 21.0491 9 18.7441 9C16.439 9 14.6144 7.18515 14.6144 5C14.6144 2.81484 16.439 1 18.7441 1C21.0491 1 22.8737 2.81484 22.8737 5Z",
    stroke: "#3D3839",
    strokeOpacity: 0.5,
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.963cd4adc272a47f6211348944715f39.svg";
export { ForwardRef as ReactComponent };